import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

export class CachedCallService{

    private results:Map<string, any> = new Map<string, any>();

    private promises:Map<string, Promise<any>> = new Map<string, Promise<any>>();

    constructor(){}

    public invokeSingleCall<T>(functionToInvoke:() => Promise<T>, key:string):Promise<T>{
        if(this.results.has(key)){
            return Promise.resolve().then( () =>{
                return this.results.get(key);
            });
        }

        if(this.promises.has(key)){
            return this.promises.get(key);
        }

        this.promises.set(key, functionToInvoke()
            .then(
                result => {
                    this.results.set(key, result);
                    return result;
                }
            )
        );

        return this.promises.get(key);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/cached-call.service.ts